import { Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BADGES } from '@hero/constants';

import * as S from './style';

// TODO: We should split that component for each different statuses (Order status, organization user invite status etc.)
function OrderStatusBadge({ status }) {
  const { t } = useTranslation();
  const badge = BADGES[status] || BADGES.default;

  return (
    <S.OrderStatusBadge color={badge.color}>
      <S.OrderStatusBadgeDot />
      <Typography variant="caption1SemiBold" fontFamily="primary">
        {badge.title && t(badge.title)}
      </Typography>
    </S.OrderStatusBadge>
  );
}

OrderStatusBadge.propTypes = {
  status: PropTypes.string
};

export { OrderStatusBadge };

OrderStatusBadge.S = S;
